// ApiContext.js
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

export const APIRequestType = Object.freeze({
    ADD_PARKS: "addParks",
    CREATE_NEW_CONTACT: "createNewContact",
    CREATE_NEW_PARK: "createNewPark",
    CREATE_NEW_USER: "createNewUser",
    DELETE_CONTACT: "deleteContact",
    DELETE_USER: "deleteUser",
    DOWNLOAD_ALL_PARKS_CSV: "downloadAllParksCsv",
    DOWNLOAD_PARK_CSV: "downloadParkCsv",
    DOWNLOAD_TURBINE_CSV: "downloadTurbineCsv",
    GET_BACKEND_VERSION: "getBackEndVersion",
    GET_CAMERA_STREAM: "getCameraStream",
    GET_CURRENT_USER: "getCurrentUser",
    GET_IMAGE: "getImage",
    GET_PARK: "getPark",
    GET_PARK_ACT_HISTOGRAM: "getParkActHistogram",
    GET_PARK_ALERTS: "getParkAlerts",
    GET_PARK_ALERTS_HISTOGRAM: "getParkAlertsHistogram",
    GET_PARK_TURBINES: "getParkTurbines",
    GET_PARKS: "getParks",
    GET_TURBINE: "getTurbine",
    GET_TURBINE_ACT_HISTOGRAM: "getTurbineActHistogram",
    GET_TURBINE_ALERTS: "getTurbineAlerts",
    GET_TURBINE_ALERTS_HISTOGRAM: "getTurbineAlertsHistogram",
    GET_USER_ACT_HISTOGRAM: "getUserParksActHistogram",
    GET_USER_ALERTS: "getUserAlerts",
    GET_USER_ALERTS_HISTOGRAM: "getUserParksAlertsHistogram",
    GET_USER_PARKS: "getUserParks",
    GET_USERS: "getUsers",
    GET_VIDEO: "getVideo",
    MODIFY_CONTACT: "modifyContact",
    MODIFY_PARK: "modifyPark",
    MODIFY_USER: "modifyUser",
    UPDATE_ALERT: "updateAlert",
});

// Creation du Contexte
const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
    const navigate = useNavigate();

    // -- ERROR -- //
    const [apiError, setApiError] = useState(null);
    const [authError, setAuthError] = useState(null);
    const [popupUserFormError, setPopupUserFormError] = useState(null);

    // -- ADMINISTRATION -- //
    const [fromDateParkFormAdm, setFromDateParkFormAdm] = useState(null);
    const [parkFormInfosAdm, setParkFormInfosAdm] = useState({
        selectedPark: null,
        formType: null,
    });
    const [parkPaAdm, setParkPaAdm] = useState([]);
    const [parksAdm, setParksAdm] = useState([]);
    const [toDateParkFormAdm, setToDateParkFormAdm] = useState(null);
    const [userFormInfosAdm, setUserFormInfosAdm] = useState({
        selectedUser: null,
        formType: null,
    });
    const [usersAdm, setUsersAdm] = useState([]);

    // -- PARK LIST -- //
    const [alertsNumPaL, setAlertsNumPaL] = useState(0);
    const [fromDatePaL, setFromDatePaL] = useState(null);
    const [parksPaL, setParksPaL] = useState([]);
    const [toDatePaL, setToDatePaL] = useState(null);

    // -- PARK DASHBOARD -- //
    const [alertsNumPaD, setAlertsNumPaD] = useState(0);
    const [fromDatePaD, setFromDatePaD] = useState(null);
    const [parkPaD, setParkPaD] = useState([]);
    const [parksPaD, setParksPaD] = useState([]);
    const [toDatePaD, setToDatePaD] = useState(null);
    const [topActivityPaD, setTopActivityPaD] = useState('');
    const [turbinesPaD, setTurbinesPaD] = useState([]);

    // -- PARK STATISTICS -- //
    const [alertsNumPaS, setAlertsNumPaS] = useState(0);
    const [fromDatePaS, setFromDatePaS] = useState(null);
    const [parkActHistogramPaS, setParkActHistogramPaS] = useState(null);
    const [parkAlertsHistogramPaS, setParkAlertsHistogramPaS] = useState(null);
    const [parkPaS, setParkPaS] = useState(null);
    const [toDatePaS, setToDatePaS] = useState(null);

    // -- PROFILE -- //
    const [backEndVersionPro, setBackEndVersionPro] = useState(null);
    const [currentUserParksPro, setCurrentUserParksPro] = useState([]);
    const [currentUserPro, setCurrentUserPro] = useState([]);

    // -- STATISTICS -- //
    const [actHistogramSta, setActHistogramSta] = useState(null);
    const [alertsHistogramSta, setAlertsHistogramSta] = useState(null);
    const [alertsNumSta, setAlertsNumSta] = useState(0);
    const [fromDateSta, setFromDateSta] = useState(null);
    const [toDateSta, setToDateSta] = useState(null);

    // -- TURBINE DASHBOARD -- //
    const [alertsTuD, setAlertsTuD] = useState([]);
    const [cameraOrientationTuD, setCameraOrientationTuD] = useState(0);
    const [fromDateTuD, setFromDateTuD] = useState(null);
    const [imageTuD, setImageTuD] = useState(false);
    const [imageUrlTuD, setImageUrlTuD] = useState('');
    const [parkTuD, setParkTuD] = useState([]);
    const [selectedAlertIDTuD, setSelectedAlertIDTuD] = useState(0);
    const [toDateTuD, setToDateTuD] = useState(null);
    const [topActivityTuD, setTopActivityTuD] = useState('');
    const [turbineTuD, setTurbineTuD] = useState([]);
    const [videoTuD, setVideoTuD] = useState(false);
    const [videoUrlTuD, setVideoUrlTuD] = useState('');

    // -- TURBINE LIVE CAMERA VIEW -- //
    const [cameraStreamUrlTuL, setCameraStreamUrlTuL] = useState(null);
    const [selectedCameraTuL, setSelectedCameraTuL] = useState(1); // Orientation de 1 à 8
    const [streamStateTuL, setStreamStateTuL] = useState(null);
    const [turbineTuL, setTurbineTuL] = useState(null);

    // -- TURBINE STATISTICS -- //
    const [alertsNumTuS, setAlertsNumTuS] = useState(0);
    const [fromDateTuS, setFromDateTuS] = useState(null);
    const [parkTuS, setParkTuS] = useState(null);
    const [toDateTuS, setToDateTuS] = useState(null);
    const [turbineActHistogramTuS, setTurbineActHistogramTuS] = useState(null);
    const [turbineAlertsHistogramTuS, setTurbineAlertsHistogramTuS] = useState(null);
    const [turbineTuS, setTurbineTuS] = useState([]);

    // -- REQUEST LOCATION -- //
    const { pathname } = useLocation();
    const isAuthPage = pathname.startsWith("/authentication");
    const isProPage = pathname.startsWith("/profile");

    const isPaLPage = pathname.startsWith("/parkList");
    const isStaPage = pathname.startsWith("/statistics");
    const isAdmPage = pathname.startsWith("/administration");

    const isPaDPage = pathname.startsWith("/parkDashboard");
    const isPaSPage = pathname.startsWith("/parkStatistics");
    const isPaAdmPage = pathname.startsWith("/parkAdministration");

    const isTuDPage = pathname.startsWith("/turbineDashboard");
    const isTuSPage = pathname.startsWith("/turbineStatistics");
    const isTuLPage = pathname.startsWith("/turbineLiveCameraView");

    const authentification = async (email, pswd) => {
        if (isAuthPage) {
            setAuthError(null);

            fetch(`${process.env.REACT_APP_BACKEND_URL}/auth`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, pswd })
            })
                .then((response) => {
                    console.log("response = ", response);
                    if (!response.ok) {
                        if (response.status === 401) {
                            setApiError("Session expired or access denied. Please log in again.");
                            return;
                        }
                        throw new Error('Invalids email and/or password');
                    }
                    return response.json();
                })
                .then((result) => {
                    console.log("result = ", result);
                    if (result.token) {
                        localStorage.setItem('userRole', result.role);
                        localStorage.setItem('userID', result.id);
                        localStorage.setItem('token', result.token);
                        navigate("/parkList"); // Redirection apres succes
                    } else {
                        setAuthError(result.error || "Authentication failed");
                    }
                })
                .catch((error) => {
                    console.error('Authentication error:', error);
                    setAuthError("INVALID VALUES");
                });
        }
    };

    const postAPI = async ({
        address,
        alertId,
        contacts,
        contactId,
        distance,
        email,
        falseAlarm,
        lastName,
        name,
        notifEmail,
        notifPhone,
        pageRequest,
        parkId,
        period,
        phone,
        position,
        pswd,
        requestType,
        role,
        status,
        updateParkList,
        userId
    }) => {
        setAuthError(null);

        const token = localStorage.getItem('token');
        if (!token) {
            setApiError("Token is missing, please login.", requestType);
            navigate("/authentification/sign-in");
            return;
        }

        try {
            const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;
            let request = baseUrl;
            const params = new URLSearchParams();

            let method = 'POST'; // Valeur par défaut
            let bodyData = {};

            console.log("requestType : ", requestType);

            switch (requestType) {
                case APIRequestType.ADD_PARKS:
                    if (isAdmPage) {
                        request += `/users/${userId}/parks`;
                        method = 'PUT';
                        const parkIdList = parkId;
                        bodyData = { parkIdList };
                    }
                    break;

                case APIRequestType.CREATE_NEW_CONTACT:
                    if (isAdmPage || isPaAdmPage) {
                        request += `/parks/${parkId}/contacts`;
                        method = 'POST';
                        bodyData = { notifEmail, notifPhone };
                    }
                    break;

                case APIRequestType.CREATE_NEW_PARK:
                    if (isAdmPage || isPaAdmPage) {
                        request += "/parks";
                        method = 'POST';
                        bodyData = { name, address, position, status, distance, period };
                    }
                    break;

                case APIRequestType.CREATE_NEW_USER:
                    if (isAdmPage) {
                        request += "/users";
                        method = 'POST';
                        bodyData = { email, phone, name, lastName, pswd, role, status };
                    }
                    break;

                case APIRequestType.DELETE_CONTACT:
                    if (isAdmPage || isPaAdmPage) {
                        request += `/contacts/${contactId}`;
                        method = 'DELETE';
                    }
                    break;

                case APIRequestType.DELETE_USER:
                    if (isAdmPage) {
                        request += `/users/${userId}`;
                        method = 'PUT';
                        bodyData = { email, phone, name, lastName, pswd, role, status };
                    }
                    break;

                case APIRequestType.MODIFY_CONTACT:
                    if (isAdmPage || isPaAdmPage) {
                        request += `/contacts/${contactId}`;
                        method = 'PUT';
                        bodyData = { notifEmail, notifPhone };
                    }
                    break;

                case APIRequestType.MODIFY_PARK:
                    if (isAdmPage || isPaAdmPage) {
                        request += `/parks/${parkId}`;
                        method = 'PUT';
                        bodyData = { name, address, position, status, distance, period };
                    }
                    break;

                case APIRequestType.MODIFY_USER:
                    if (isAdmPage || isProPage) {
                        request += `/users/${userId}`;
                        method = 'PUT';
                        bodyData = { email, phone, name, lastName, pswd, role, status };
                    }
                    break;

                case APIRequestType.UPDATE_ALERT:
                    if (isTuDPage) {
                        request += `/alerts/${alertId}`;
                        method = 'PUT';
                        console.log("             F A L S E   alarm: ", falseAlarm);
                        bodyData = { falseAlarm };
                    }
                    break;

                default:
                    console.error("Invalid request type:", requestType);
                    return;
            }

            if ([...params].length > 0) {
                request += `?${params.toString()}`;
            }

            console.log("REQUEST:", request, "Method:", method, "Body:", bodyData);

            const response = await fetch(request, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(bodyData)
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setApiError("Session expired or access denied. Please log in again.");
                    localStorage.removeItem('token');
                    navigate("/authentification/sign-in");
                    return;
                } else if (response.status === 409) {
                    setPopupUserFormError("An account already exists with this email address. Please enter a new one.");
                    return;
                }
                throw new Error(`Error retrieving ${requestType}`);
            }

            const result = await response.json();
            console.log("Result : ", result);

            switch (requestType) {
                case APIRequestType.ADD_PARKS:
                    if (result) {
                        setUserFormInfosAdm({
                            selectedUser: null,
                            formType: "Tab",
                        });
                        console.log("Return USER Tab");
                    }
                    break;

                case APIRequestType.CREATE_NEW_CONTACT:
                    if (result) {
                        console.log("requestType : ", requestType, "   result : ", result);
                    }
                    break;

                case APIRequestType.CREATE_NEW_PARK:
                    if (result) {
                        setParkFormInfosAdm({
                            selectedPark: null,
                            formType: "Tab",
                        });
                        console.log("Return PARK Tab");

                        if (Array.isArray(contacts)) {
                            contacts.forEach(async (contact) => {
                                const { id, state, phone, email } = contact;

                                if (id === null && state === "visible") {
                                    // CREATE
                                    await postAPI({
                                        requestType: APIRequestType.CREATE_NEW_CONTACT,
                                        notifPhone: phone,
                                        notifEmail: email,
                                        parkId: result.parkId,
                                    });
                                } else if (typeof id === "number" && state === "visible") {
                                    // MODIFY
                                    await postAPI({
                                        requestType: APIRequestType.MODIFY_CONTACT,
                                        notifPhone: phone,
                                        notifEmail: email,
                                        contactId: id,
                                    });
                                } else if (typeof id === "number" && state === "hide") {
                                    // DELETE
                                    await postAPI({
                                        requestType: APIRequestType.DELETE_CONTACT,
                                        contactId: id,
                                    });
                                }
                                // Si id === null && state === "hide" => on ignore
                            });
                        }
                    }
                    break;

                case APIRequestType.CREATE_NEW_USER:
                    if (result) {
                        if (!result.error) {
                            setPopupUserFormError(null);
                            postAPI({
                                requestType: APIRequestType.ADD_PARKS,
                                parkId,
                                userId: result.userId
                            });
                        } else {
                            console.log("   E.R.R.O.R : ", result.error);
                            setPopupUserFormError(result.error);
                        }
                    }
                    break;

                case APIRequestType.DELETE_CONTACT:
                    if (result) {
                        console.log("DELETE_CONTACT : ", requestType, "   result : ", result);
                    }
                    break;

                case APIRequestType.DELETE_USER:
                    if (result) {
                        console.log("DELETE_USER : ", requestType, "   result : ", result);
                    }
                    break;

                case APIRequestType.MODIFY_CONTACT:
                    if (result) {
                        console.log("MODIFY_CONTACT : ", requestType, "   result : ", result);
                    }
                    break;

                case APIRequestType.MODIFY_PARK:
                    if (result) {
                        setParkFormInfosAdm({
                            selectedPark: null,
                            formType: "Tab",
                        });
                        console.log("Return PARK Tab");

                        if (Array.isArray(contacts)) {
                            contacts.forEach(async (contact) => {
                                const { id, state, phone, email } = contact;

                                if (id === null && state === "visible") {
                                    // CREATE
                                    console.log("CREATE NEW CONTACT  id: ", id, "   state : ", state);
                                    await postAPI({
                                        requestType: APIRequestType.CREATE_NEW_CONTACT,
                                        notifPhone: phone,
                                        notifEmail: email,
                                        parkId: result.parkId,
                                    });
                                } else if (typeof id === "number" && state === "visible") {
                                    // MODIFY
                                    console.log("MODIFY CONTACT  id: ", id, "   state : ", state);
                                    await postAPI({
                                        requestType: APIRequestType.MODIFY_CONTACT,
                                        notifPhone: phone,
                                        notifEmail: email,
                                        contactId: id,
                                    });
                                } else if (typeof id === "number" && state === "hide") {
                                    // DELETE
                                    console.log("DELETE CONTACT  id: ", id, "   state : ", state);
                                    await postAPI({
                                        requestType: APIRequestType.DELETE_CONTACT,
                                        contactId: id,
                                    });
                                } else {
                                    console.log("nothing CONTACT  id: ", id, "   state : ", state);
                                }
                                // Si id === null && state === "hide" => on ignore
                            });
                        }
                    }
                    break;

                case APIRequestType.MODIFY_USER:
                    if (result) {
                        if (updateParkList) {
                            postAPI({
                                requestType: APIRequestType.ADD_PARKS,
                                parkId,
                                userId: result.userId
                            });
                        } else if (pageRequest === "Profile") {
                            navigate("/parkList");
                        }
                    }
                    break;

                case APIRequestType.UPDATE_ALERT:
                    if (result) {
                        console.log("requestType : ", requestType, "   result : ", result);
                    }
                    break;
            }


        } catch (error) {
            console.error('Error retrieving:', requestType, error);
            setApiError(`Network error occurred while retrieving: ${requestType}`);
        }
    };

    const streamRequestIdRef = useRef(0);

    const getAPI = async (requestType, alertId = 1) => {
        setApiError(null);

        const token = localStorage.getItem('token');
        if (!token) {
            setApiError("Token is missing, please login. ", requestType);
            navigate("/authentification/sign-in");
            return;
        }

        try {
            const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;
            let request = baseUrl;
            const params = new URLSearchParams();

            const savedParkID = localStorage.getItem('selectedParkID');
            const savedTurbineID = localStorage.getItem('selectedTurbineID');
            const userID = localStorage.getItem('userID');

            let fromDate = null;
            let toDate = null;

            // Fonction utilitaire pour ajouter les paramètres 'from' et 'to' si valides
            function appendDateParams(fromDate, toDate) {
                if (fromDate) params.append("from", fromDate.format("YYYY-MM-DD"));
                if (toDate) params.append("to", toDate.format("YYYY-MM-DD"));
            }

            // Fonction utilitaire pour gérer les pages avec filtres de date
            function handleDateFilters(pageFlag, fromDate, toDate, addCSV = false) {
                if (pageFlag) {
                    appendDateParams(fromDate, toDate);
                    if (addCSV) params.append("csv", "1");
                }
            }

            function waitForStream(m3u8Url, callback, localRequestId, attempts = 0) {
                console.log('WAIT FOR STREAM : Attempt', attempts, 'ID:', localRequestId);

                // Si une nouvelle requête a été lancée entre-temps, on abandonne
                if (localRequestId !== streamRequestIdRef.current) {
                    console.log('Aborting old stream request');
                    return;
                }

                if (attempts > 15) {
                    setStreamStateTuL("NOT FOUND");
                    console.log('Stream not found after several attempts.');
                    return;
                }

                fetch(m3u8Url, { method: 'HEAD' })
                    .then((res) => {
                        if (localRequestId !== streamRequestIdRef.current) {
                            console.log('Stream check skipped: outdated request ID');
                            return;
                        }

                        if (res.ok) {
                            setStreamStateTuL("FOUND");
                            callback();
                        } else {
                            setTimeout(() => waitForStream(m3u8Url, callback, localRequestId, attempts + 1), 2000);
                        }
                    })
                    .catch((err) => {
                        console.error("Stream fetch error", err);
                        setTimeout(() => waitForStream(m3u8Url, callback, localRequestId, attempts + 1), 2000);
                    });
            }


            // Utilisation de l'Enum pour choisir le bon endpoint
            switch (requestType) {
                case APIRequestType.DOWNLOAD_ALL_PARKS_CSV:
                    if (isStaPage) {
                        request += `/parks/kpi/histogram/detections`;
                        handleDateFilters(isStaPage, fromDateSta, toDateSta, true);
                    }
                    break;

                case APIRequestType.DOWNLOAD_PARK_CSV:
                    if (isPaSPage) {
                        if (savedParkID) {
                            request += `/parks/${savedParkID}/kpi/histogram/detections`;
                            handleDateFilters(isPaSPage, fromDatePaS, toDatePaS, true);
                        }
                    }
                    break;

                case APIRequestType.DOWNLOAD_TURBINE_CSV:
                    if (isTuSPage) {
                        if (savedTurbineID) {
                            request += `/windmills/${savedTurbineID}/kpi/histogram/detections`;
                            handleDateFilters(isTuSPage, fromDateTuS, toDateTuS, true);
                        }
                    }
                    break;

                case APIRequestType.GET_BACKEND_VERSION:
                    if (isProPage) {
                        request += "/version";
                    }
                    break;

                case APIRequestType.GET_CAMERA_STREAM:
                    if (isTuLPage) {
                        const camera = turbineTuL?.cameras?.find(
                            (camera) => camera.orientation === selectedCameraTuL
                        );

                        const cameraId = camera?.id ?? 0;
                        request += `/cameras/${cameraId}/stream`;
                    }
                    break;

                case APIRequestType.GET_CURRENT_USER:
                    if (isProPage) {
                        if (userID) request += `/users/${userID}`;
                    }
                    break;

                case APIRequestType.GET_PARK:
                    if (isPaDPage || isPaSPage || isPaAdmPage || isTuDPage || isTuSPage) {
                        if (savedParkID) request += `/parks/${savedParkID}`;
                    }
                    break;

                case APIRequestType.GET_PARK_ALERTS:
                    if (isPaSPage) {
                        if (!savedParkID) break;
                        request += `/parks/${savedParkID}/alerts`;
                        // Choix des dates selon la page active
                        fromDate = isPaDPage ? fromDatePaD : isPaSPage ? fromDatePaS : null;
                        toDate = isPaDPage ? toDatePaD : isPaSPage ? toDatePaS : null;
                        appendDateParams(fromDate, toDate);
                    }
                    break;

                case APIRequestType.GET_PARK_ACT_HISTOGRAM:
                    if (isPaSPage) {
                        if (savedParkID) {
                            request += `/parks/${savedParkID}/kpi/histogram/activities`;
                            handleDateFilters(isPaSPage, fromDatePaS, toDatePaS);
                        }
                    }
                    break;

                case APIRequestType.GET_PARK_ALERTS_HISTOGRAM:
                    if (isPaSPage) {
                        if (savedParkID) {
                            request += `/parks/${savedParkID}/kpi/histogram/detections`;
                            handleDateFilters(isPaSPage, fromDatePaS, toDatePaS);
                        }
                    }
                    break;

                case APIRequestType.GET_PARKS:
                    if (isAdmPage) {
                        request += "/parks";
                        handleDateFilters(isPaLPage, fromDatePaL, toDatePaL);
                    }
                    break;

                case APIRequestType.GET_PARK_TURBINES:
                    if (isPaDPage) {
                        if (savedParkID) {
                            request += `/parks/${savedParkID}/windmills`;
                            handleDateFilters(isPaDPage, fromDatePaD, toDatePaD);
                        }
                    }
                    break;

                case APIRequestType.GET_IMAGE:
                    if (isTuDPage) {
                        if (!alertId) throw new Error("Alert ID is required for fetching an image.");
                        request += `/alerts/${alertId}/photo`;
                    }
                    break;

                case APIRequestType.GET_TURBINE:
                    if (isTuDPage || isTuLPage) {
                        if (savedTurbineID) request += `/windmills/${savedTurbineID}`;
                    }
                    break;

                case APIRequestType.GET_TURBINE_ALERTS:
                    if (isTuDPage || isTuSPage) {
                        if (!savedTurbineID) break;
                        request += `/windmills/${savedTurbineID}/alerts`;
                        // Choix des dates selon la page active
                        fromDate = isTuDPage ? fromDateTuD : isTuSPage ? fromDateTuS : null;
                        toDate = isTuDPage ? toDateTuD : isTuSPage ? toDateTuS : null;
                        appendDateParams(fromDate, toDate);
                    }
                    break;

                case APIRequestType.GET_TURBINE_ACT_HISTOGRAM:
                    if (isTuSPage) {
                        if (savedTurbineID) {
                            request += `/windmills/${savedTurbineID}/kpi/histogram/activities`;
                            handleDateFilters(isTuSPage, fromDateTuS, toDateTuS);
                        }
                    }
                    break;

                case APIRequestType.GET_TURBINE_ALERTS_HISTOGRAM:
                    if (isTuSPage) {
                        if (savedTurbineID) {
                            request += `/windmills/${savedTurbineID}/kpi/histogram/detections`;
                            handleDateFilters(isTuSPage, fromDateTuS, toDateTuS);
                        }
                    }
                    break;

                case APIRequestType.GET_USER_ALERTS:
                    if (isStaPage) {
                        if (userID) {
                            request += `/users/${userID}/alerts`;
                            handleDateFilters(isStaPage, fromDateSta, toDateSta);
                        }
                    }
                    break;

                case APIRequestType.GET_USER_PARKS:
                    if (isPaLPage) {
                        if (userID) {
                            request += `/users/${userID}/parks`;
                            handleDateFilters(isPaLPage, fromDatePaL, toDatePaL);
                        }
                    }
                    break;

                case APIRequestType.GET_USER_ACT_HISTOGRAM:
                    if (isStaPage) {
                        request += `/parks/kpi/histogram/activities`;
                        handleDateFilters(isStaPage, fromDateSta, toDateSta);
                    }
                    break;

                case APIRequestType.GET_USER_ALERTS_HISTOGRAM:
                    if (isStaPage) {
                        request += `/parks/kpi/histogram/detections`;
                        handleDateFilters(isStaPage, fromDateSta, toDateSta);
                    }
                    break;

                case APIRequestType.GET_USERS:
                    if (isAdmPage) {
                        request += `/users`;
                    }
                    break;

                case APIRequestType.GET_VIDEO:
                    if (isTuDPage) {
                        if (!alertId) throw new Error("Alert ID is required for fetching a video.");
                        request += `/alerts/${alertId}/video`;
                    }
                    break;

                default:
                    console.error("Invalid request type:", requestType);
                    return;
            }

            // Ajout des parametres uniquement si necessaire
            if ([...params].length > 0) {
                request += `?${params.toString()}`;
            }
            console.log(" R E Q U E S T : ", request);
            const response = await fetch(request, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': (requestType === APIRequestType.GET_IMAGE || requestType === APIRequestType.GET_VIDEO)
                        ? 'application/octet-stream'
                        : 'application/json',
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setApiError("Session expired or access denied. Please log in again.");
                    localStorage.removeItem('token');
                    navigate("/authentification/sign-in");
                    return;
                }
                if (requestType === APIRequestType.GET_IMAGE) {
                    setImageTuD(false);
                    console.log(" NO IMAGE ");
                } else if (requestType === APIRequestType.GET_VIDEO) {
                    setVideoTuD(false);
                    console.log(" NO VIDEO ");

                }
                throw new Error(`Error retrieving ${requestType}`);
            }

            if (requestType === APIRequestType.GET_IMAGE || requestType === APIRequestType.GET_VIDEO) {
                const blob = await response.blob();
                const mediaUrl = URL.createObjectURL(blob);
                if (requestType === APIRequestType.GET_IMAGE) {
                    setImageTuD(true);
                    setImageUrlTuD(mediaUrl);
                    console.log("Image URL:", mediaUrl);
                } else { // GET VIDEO //
                    setVideoTuD(true);
                    setVideoUrlTuD(mediaUrl);
                    console.log("Video URL:", mediaUrl);
                }

            } else if (
                requestType === APIRequestType.DOWNLOAD_ALL_PARKS_CSV ||
                requestType === APIRequestType.DOWNLOAD_PARK_CSV ||
                requestType === APIRequestType.DOWNLOAD_TURBINE_CSV
            ) {

                function formatDateToYYYYMMDD(date) {
                    if (!date) return '..';
                    const d = new Date(date);
                    return d.getFullYear() + '-' +
                        String(d.getMonth() + 1).padStart(2, '0') + '-' +
                        String(d.getDate()).padStart(2, '0');
                }

                const csvText = await response.text();
                const now = new Date();
                const timestamp = formatDateToYYYYMMDD(now);

                // Création d’un lien de téléchargement
                const blob = new Blob([csvText], { type: 'text/csv' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                if (requestType === APIRequestType.DOWNLOAD_ALL_PARKS_CSV) {
                    a.download = `(${timestamp})_PARKS_Statistics_(From.${formatDateToYYYYMMDD(fromDateSta)}_To.${formatDateToYYYYMMDD(toDateSta)}).csv`;
                } else if (requestType === APIRequestType.DOWNLOAD_PARK_CSV) {
                    a.download = `(${timestamp})_${parkPaS.park.name}_Statistics_(From.${formatDateToYYYYMMDD(fromDatePaS)}_To.${formatDateToYYYYMMDD(toDatePaS)}).csv`;
                } else if (requestType === APIRequestType.DOWNLOAD_TURBINE_CSV) {
                    a.download = `(${timestamp})_E${turbineTuS.number}_${parkTuS.park.name}_Statistics_(From.${formatDateToYYYYMMDD(fromDateTuS)}_To.${formatDateToYYYYMMDD(toDateTuS)}).csv`;
                }

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                console.log("CSV file downloaded.");

            } else if (requestType === APIRequestType.GET_CAMERA_STREAM) {
                if (response.ok) {
                    const result = await response.json();
                    console.log("Get Camera Stream.     response :", response);
                    console.log("Get Camera Stream.     result :", result);
                    const fullStreamUrl = `${process.env.REACT_APP_BACKEND_URL}${result.streamUrl}`;

                    // Nouvelle requête : on incrémente l'ID
                    streamRequestIdRef.current += 1;
                    const currentRequestId = streamRequestIdRef.current;

                    // Lancer le waitForStream avec l’ID local
                    waitForStream(fullStreamUrl, () => {
                        console.log(" fullStreamUrl : ", fullStreamUrl);
                        setCameraStreamUrlTuL(fullStreamUrl);
                    }, currentRequestId);
                } else {
                    alert(`Stream request failed with status: ${response.status}`);
                }

            } else {
                const result = await response.json();
                let currentUser = "";

                switch (requestType) {
                    case APIRequestType.GET_BACKEND_VERSION:
                        setBackEndVersionPro(result);
                        console.log("BACKEND Version:", result);
                        break;

                    case APIRequestType.GET_CURRENT_USER:
                        currentUser = result.user;
                        setCurrentUserPro(currentUser);
                        setCurrentUserParksPro(currentUser.parks);
                        console.log("Current User:", currentUser);
                        console.log("Current User Parks:", currentUser.parks);
                        break;

                    case APIRequestType.GET_PARK:
                        setParkPaAdm(result.park);
                        setParkPaD(result.park);
                        setParkPaS(result);
                        setParkTuD(result.park);
                        setParkTuS(result);
                        console.log("Park:", result);
                        break;

                    case APIRequestType.GET_PARK_ALERTS:
                        setAlertsNumPaS(result.alertCount);
                        console.log("Park Alerts Number:", result.alertCount);
                        break;

                    case APIRequestType.GET_PARK_ACT_HISTOGRAM:
                        setParkActHistogramPaS(result);
                        console.log("Park Activities HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_PARK_ALERTS_HISTOGRAM:
                        setParkAlertsHistogramPaS(result);
                        console.log("Park Alerts HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_PARKS:
                        setParksAdm(result.park_list);
                        console.log("Park List:", result);
                        break;

                    case APIRequestType.GET_PARK_TURBINES:
                        setTurbinesPaD(result.windmillList);
                        setAlertsNumPaD(result.alertCount);
                        setTopActivityPaD(result.alertCount > 0 ? result.mostUsedActivity.type : "__");
                        console.log("Park Turbines:", result);
                        break;

                    case APIRequestType.GET_TURBINE:
                        setTopActivityTuD(result.alertCount > 0 ? result.mostUsedActivity.type : "__");
                        setTurbineTuD(result.windmill);
                        setTurbineTuS(result.windmill);
                        setTurbineTuL(result.windmill);
                        console.log("Turbine:", result);
                        break;

                    case APIRequestType.GET_TURBINE_ALERTS:
                        setAlertsTuD(result.alertList);
                        setAlertsNumTuS(result.alertCount);
                        console.log("Turbine Alerts Number:", result.alertCount);
                        console.log("Turbine alerts:", result.alertList);
                        break;

                    case APIRequestType.GET_TURBINE_ACT_HISTOGRAM:
                        setTurbineActHistogramTuS(result);
                        console.log("Turbine Activities HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_TURBINE_ALERTS_HISTOGRAM:
                        setTurbineAlertsHistogramTuS(result);
                        console.log("Turbine Alerts HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_USERS:
                        setUsersAdm(result);
                        console.log("Users List:", result);
                        break;

                    case APIRequestType.GET_USER_ALERTS:
                        setAlertsNumSta(result.alertCount);
                        console.log("User Alerts ALL PARKS:", result);
                        break;

                    case APIRequestType.GET_USER_ACT_HISTOGRAM:
                        setActHistogramSta(result);
                        console.log("ALL Activities HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_USER_ALERTS_HISTOGRAM:
                        setAlertsHistogramSta(result);
                        console.log("ALL Alerts HISTOGRAM:", result);
                        break;

                    case APIRequestType.GET_USER_PARKS:
                        setParksPaL(result.park_list);
                        setAlertsNumPaL(result.alertCount);
                        console.log("User Park List:", result);
                        break;
                }
            }
        } catch (error) {
            console.error('Error retrieving:', requestType, error);
            setApiError(`Network error occurred while retrieving: ${requestType}`);
        }
    };

    useEffect(() => {
        return () => {
            if (imageUrlTuD) {
                URL.revokeObjectURL(imageUrlTuD);
            }
        };
    }, [imageUrlTuD]);

    useEffect(() => {
        // Nettoyage de l'URL lorsque la video n'est plus utilisee
        return () => {
            if (videoUrlTuD) {
                URL.revokeObjectURL(videoUrlTuD);
            }
        };
    }, [videoUrlTuD]);  // Ce useEffect sera declenche a chaque fois que videoUrl change

    return (
        <ApiContext.Provider value={{
            APIRequestType,

            // -- ERROR -- //
            apiError, setApiError,
            authError, setAuthError,
            popupUserFormError, setPopupUserFormError,

            // -- ADMINISTRATION -- //
            fromDateParkFormAdm, setFromDateParkFormAdm,
            parkFormInfosAdm, setParkFormInfosAdm,
            parkPaAdm, setParkPaAdm,
            parksAdm, setParksAdm,
            toDateParkFormAdm, setToDateParkFormAdm,
            userFormInfosAdm, setUserFormInfosAdm,
            usersAdm, setUsersAdm,

            // -- PARK LIST -- //
            alertsNumPaL, setAlertsNumPaL,
            fromDatePaL, setFromDatePaL,
            parksPaL, setParksPaL,
            toDatePaL, setToDatePaL,

            // -- PARK DASHBOARD -- //
            alertsNumPaD, setAlertsNumPaD,
            fromDatePaD, setFromDatePaD,
            parkPaD, setParkPaD,
            parksPaD, setParksPaD,
            toDatePaD, setToDatePaD,
            topActivityPaD, setTopActivityPaD,
            turbinesPaD, setTurbinesPaD,

            // -- PARK STATISTICS -- //
            alertsNumPaS, setAlertsNumPaS,
            fromDatePaS, setFromDatePaS,
            parkActHistogramPaS, setParkActHistogramPaS,
            parkAlertsHistogramPaS, setParkAlertsHistogramPaS,
            parkPaS, setParkPaS,
            toDatePaS, setToDatePaS,

            // -- PROFILE -- //
            backEndVersionPro, setBackEndVersionPro,
            currentUserParksPro, setCurrentUserParksPro,
            currentUserPro, setCurrentUserPro,

            // -- STATISTICS -- //
            actHistogramSta, setActHistogramSta,
            alertsHistogramSta, setAlertsHistogramSta,
            alertsNumSta, setAlertsNumSta,
            fromDateSta, setFromDateSta,
            toDateSta, setToDateSta,

            // -- TURBINE DASHBOARD -- //
            alertsTuD, setAlertsTuD,
            cameraOrientationTuD, setCameraOrientationTuD,
            fromDateTuD, setFromDateTuD,
            imageTuD, setImageTuD,
            imageUrlTuD, setImageUrlTuD,
            parkTuD, setParkTuD,
            selectedAlertIDTuD, setSelectedAlertIDTuD,
            toDateTuD, setToDateTuD,
            topActivityTuD, setTopActivityTuD,
            turbineTuD, setTurbineTuD,
            videoTuD, setVideoTuD,
            videoUrlTuD, setVideoUrlTuD,

            // -- TURBINE LIVE CAMERA VIEW -- //
            cameraStreamUrlTuL, setCameraStreamUrlTuL,
            selectedCameraTuL, setSelectedCameraTuL,
            streamStateTuL, setStreamStateTuL,
            turbineTuL, setTurbineTuL,

            // -- TURBINE STATISTICS -- //
            alertsNumTuS, setAlertsNumTuS,
            fromDateTuS, setFromDateTuS,
            parkTuS, setParkTuS,
            toDateTuS, setToDateTuS,
            turbineActHistogramTuS, setTurbineActHistogramTuS,
            turbineAlertsHistogramTuS, setTurbineAlertsHistogramTuS,
            turbineTuS, setTurbineTuS,

            // -- FUNCTIONS -- //
            authentification,
            getAPI,
            postAPI
        }}>
            {children}
        </ApiContext.Provider>
    );
};

// Hook personnalise pour acceder au contexte
export const useApiContext = () => useContext(ApiContext);
